import linkResolver from '../../../../../../prismic/linkResolver'

export default ({
  element: {
    data,
  },
}) => (
  linkResolver(data)
)
